import { t } from 'i18next';
import { useCallback, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as Logout } from '../assets/svg/logout.svg';
import { useAlert } from '../components/alert';
import { extractErrorDetail } from '../components/common';
import Button from '../components/mplat/Button/Button';
import Content from '../components/mplat/Content';
import Form from '../components/mplat/Form';
import Header1 from '../components/mplat/Header1';
import Label from '../components/mplat/Label';
import Section from '../components/mplat/Section';
import TextInput from '../components/mplat/TextInput';
import { useLanguage } from '../hooks';
import { useGetOTPQuery, useLazyGetProfileQuery, useRegisterOTPMutation, useResetOTPMutation, useVerifyOTPMutation } from '../services/users_v1';


function OtpVerifyPage() {
    const alert = useAlert();
    const lang = useLanguage();
    const { data: otp, error, refetch } = useGetOTPQuery(undefined);
    const [fetchProfile] = useLazyGetProfileQuery();

    const [qr, setQR] = useState('');
    const [resetOTP] = useResetOTPMutation();
    const [regOTP] = useRegisterOTPMutation();
    const [verifyOTP] = useVerifyOTPMutation();

    const [token, setToken] = useState('');

    useEffect(() => {
        regOTP().unwrap().then((data) => {
            setQR(data.results.qrcode)
        }).catch((res) => {
            if (res?.data?.response?.status?.code === 118) {
                console.log('ALREADY EXISTS');
            }
        });
    }, [otp]);

    const onVerify = useCallback(() => {
        verifyOTP({ token: token }).unwrap()
            .then(() => {
                refetch();
                fetchProfile(new Date().toISOString());
            })
            .catch((err) => alert.error(extractErrorDetail(err)));
    }, [token]);

    const content = <Content>
        {/* <div className="content__side-btn">
            <Link to="/logout" title={t('Log out')}>
                <Button className="_bd">
                    Авторизоваться
                    &nbsp;
                    <Logout />
                </Button>
            </Link>
        </div> */}
        <div className="user-settings">
            <Header1>
                <Trans>profile:2FA</Trans>
            </Header1>
            {error ? JSON.stringify(error) :
                <Form>
                    {otp?.results.otp_configured ?
                        <Section label={'Вы успешно настроили двухфакторную аутентификацию!'}>
                            <p>
                                Для дальнейшей работы, пожалуйста, нажмите «Авторизоваться» и пройдите авторизацию повторно.<br />
                                После ввода логина и пароля у вас будет запрошен код из приложения.
                            </p>
                            <p>
                                Если вы хотите отменить настройку 2-факторной авторизации - нажмите «Сбросить».
                            </p>
                            <div className="form__item" style={{ textAlign: 'center' }}>
                                <Link to="/logout" title={t('Log out')}>
                                    <Button className="_bd">
                                        <Trans>Login2</Trans>
                                        &nbsp;
                                        <Logout />
                                    </Button>
                                </Link>
                                {' '}
                                <Button onClick={() => {
                                    const ret = confirm('Вы уверены, что хотите сбросить текущую настройку 2fa?');
                                    if (ret) {
                                        resetOTP().unwrap().then((w) => { refetch(); console.log(w); });
                                    }
                                }}>
                                    <Trans>account:RESET</Trans>
                                </Button>
                            </div>
                        </Section>
                        :
                        <Section label={'Для безопасной загрузки и передачи ваших файлов, необходимо пройти дополнительную аутентификацию, подтверждающую личность.'}>
                            {lang === 'ru' ? <><p>
                                Пожалуйста, установите любое 2FA приложение на ваш телефон и отсканируйте с помощью него QR-код с этой страницы.
                                Программа сгенерирует код. Добавьте в строку ниже сгенерированный в приложении код.
                                В дальнейшем, при авторизации на платформе Медиабазы, у вас также будет запрашиваться код из установленного на телефоне приложения.
                            </p>
                                <p>
                                    Для генерации кодов мы рекомендуем использовать приложение
                                    {' '}
                                    <a className="link-accent" href="https://yandex.ru/id/key/main" target="_blank">Яндекс.Ключ</a>
                                    {' или '}
                                    <a className="link-accent" href="https://support.google.com/accounts/answer/1066447?hl=ru&ref_topic=2954345&sjid=9699348225073229469-NA" target="_blank">Google&nbsp;Authenticator</a>
                                </p>
                            </>
                                :
                                <>
                                    <p>
                                        For security reasons, additional verification (2FA) is required to enable file upload and transfer:
                                        Please install any 2FA app on your phone and scan below QR code by the app.
                                        The application will generate a code. Enter the generated code in the field below.
                                        Please be aware that you will need this app and generated code to log in to the Mediabaza platform in the future.
                                    </p>
                                    <p>
                                        For 2FA code generation, we recommend using the most common apps:
                                        {' '}
                                        <a className="link-accent" href="https://yandex.ru/id/key/main" target="_blank">Yandex.Key</a>
                                        {' or '}
                                        <a className="link-accent" href="https://support.google.com/accounts/answer/1066447?hl=en&ref_topic=2954345&sjid=9699348225073229469-NA" target="_blank">Google&nbsp;Authenticator</a>
                                    </p>
                                </>
                            }

                            <div className="form__item" style={{ textAlign: 'center' }}>
                                {qr && <img src={qr} width="300px" alt="QRCode" />}
                            </div>
                            <div className="form__item">
                                <Label>
                                    <Trans>Enter one-time code</Trans>
                                </Label>
                                <TextInput value={token} onChange={(e) => setToken(e.target.value)} onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onVerify();
                                    }
                                }} />
                            </div>
                            <Button onClick={onVerify}><Trans>Send</Trans></Button>
                        </Section>
                    }
                </Form>
            }
        </div>
    </Content>

    return content;
}

export default OtpVerifyPage;
